import { executeQuery } from "src/store";
import { baseService } from "src/store/base.store";
import { callFunctionSafe } from "src/firebase/functions";
import { billingExceptionsRepository } from "./billing-exceptions.repository";
import { BillingExceptionsPage, BillingExceptionsQuery } from "./types/billing-exception.entity";

export type StripePaymentReconciliationResult = {
  scanned: number;
  succeeded: number;
  canceled: number;
  stillPending: number;
  skipped: number;
  failed: number;
};

const billingExceptionsService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getBillingExceptions: builder.query<BillingExceptionsPage, BillingExceptionsQuery>({
      queryFn: async ({ scope, offset }) => {
        const result = await executeQuery(() => billingExceptionsRepository.find(scope, offset));

        if ("error" in result) return { error: result.error } as any;
        return { data: result.data as BillingExceptionsPage };
      },
    }),

    reconcileStaleStripePaymentIntents: builder.mutation<
      StripePaymentReconciliationResult,
      void
    >({
      queryFn: async () => {
        try {
          const result = await callFunctionSafe<StripePaymentReconciliationResult>(
            "reconcileStaleStripePaymentIntents",
            {}
          );

          if ("error" in result) {
            return { error: { status: 500, data: result.error } };
          }

          return { data: result.data };
        } catch (error) {
          return { error: { status: 500, data: error } };
        }
      },
    }),
  }),
});

export const {
  useGetBillingExceptionsQuery,
  useReconcileStaleStripePaymentIntentsMutation,
} = billingExceptionsService;
